import { ModalContent, Header, Stack } from '@lightspeed/design-system-react'
import { VendImage } from '@vend/react-utilities'
import React, { FC } from 'react'
import { useT } from '@transifex/react'
import { SwiperErrorMessage } from '../../hooks/use-swiper-payment-reducer/types'
import { useTransaction } from '../../hooks/use-transaction/useTransaction'
import { Transaction } from '../../queries/Transaction'

const heightStyle = { height: 200 }

interface Props {
  registerID: string
  retailerPaymentTypeID: string
  registerSalePaymentID: string
  amount: number
  currency: string
  originalRegisterSalePaymentID?: string
  onComplete: (transaction: Transaction) => void
  onError: (errorMessage: SwiperErrorMessage) => void
  isRefund: boolean
  paymentTypeID: number
}

export const ProcessingTransaction: FC<Props> = ({
  registerID,
  retailerPaymentTypeID,
  registerSalePaymentID,
  amount,
  currency,
  originalRegisterSalePaymentID,
  onComplete,
  onError,
  isRefund,
  paymentTypeID,
}) => {
  useTransaction(isRefund, onComplete, onError, {
    registerSalePaymentID,
    amount,
    currency,
    registerID,
    retailerPaymentTypeID,
    originalRegisterSalePaymentID,
    paymentTypeID,
  })
  const t = useT()

  return (
    <ModalContent className="vd-flex vd-flex--justify-center vd-flex--align-center">
      <Stack
        className="vd-flex--justify-center"
        align="center"
        style={heightStyle}
        space={5}
      >
        <VendImage relativeImagePath="payments/insert-card-v1.svg" width={59} />
        <Header level="1" type="heading">
          {t('Waiting for card…', {
            _context:
              'The message shown when waiting for card to be presented for processing payment',
          })}
        </Header>
      </Stack>
    </ModalContent>
  )
}
